import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/exclamation-triangle-fill-yellow.svg'
import _imports_1 from '@/assets/img/check-circle-fill-green.svg'
import _imports_2 from '@/assets/img/exclamation-octagon-fill-red.svg'


const _withScopeId = n => (_pushScopeId("data-v-cb81df7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_3 = {
  key: 2,
  class: "d-flex align-items-center justify-content-end"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_6 = { class: "bannedProviderAlert" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.opensanctions.org/",
  target: "_blank",
  class: "fs_14 fw_700"
}, "https://www.opensanctions.org/", -1))
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center mb-4 pb-2 fs_14"
}
const _hoisted_10 = {
  src: _imports_1,
  class: "me-1"
}
const _hoisted_11 = {
  src: _imports_0,
  class: "me-1"
}
const _hoisted_12 = {
  src: _imports_2,
  class: "me-1"
}
const _hoisted_13 = {
  href: "/docs/countryRisks.xlsx",
  target: "_blank",
  class: "ms-1"
}
const _hoisted_14 = {
  key: 2,
  class: "d-flex align-items-center justify-content-center mt-4 pt-4 mb-5"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_17 = {
  key: 3,
  class: "mt-5"
}
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!
  const _component_provider_garment_productions_table = _resolveComponent("provider-garment-productions-table")!
  const _component_docs_and_certifications = _resolveComponent("docs-and-certifications")!
  const _component_water_footprints = _resolveComponent("water-footprints")!
  const _component_provider_due_diligence = _resolveComponent("provider-due-diligence")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.model.providerName)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.model.providerName), 1))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            type: 'h1',
            localizedKey: "Create provider",
            text: "Create provider",
            class: "mb-0"
          })),
      (_ctx.model.providerName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn me-2", _ctx.activeSection == 1 ? 'btn-tertiary': 'btn-secondary withBorder']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeSection = 1))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Personal Info & garments",
                text: "Personal Info & garments"
              })
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btn me-2", _ctx.activeSection == 2 ? 'btn-tertiary': 'btn-secondary withBorder']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeSection = 2))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Docs & Certifications",
                text: "Docs & Certifications"
              })
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["btn me-2", _ctx.activeSection == 3 ? 'btn-tertiary': 'btn-secondary withBorder']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeSection = 3))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Water Footprint",
                text: "Water Footprint"
              })
            ], 2),
            (_ctx.hasDueDiligenceLicense)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["btn", _ctx.activeSection == 4 ? 'btn-tertiary': 'btn-secondary withBorder']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeSection = 4))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Due Diligence",
                    text: "Due Diligence"
                  })
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.activeSection == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_localized_text, {
                    localizedKey: "Before proceeding, check if your provider is legitimate and not banned:",
                    text: "Before proceeding, check if your provider is legitimate and not banned:",
                    class: "fs_14 fw_700 mx-1"
                  }),
                  _hoisted_8
                ]),
                _createVNode(_component_form_field, {
                  type: "text",
                  labelKey: "Provider name*",
                  labelValue: "Provider name*",
                  placeholderKey: "Provider name",
                  placeholderValue: "Provider name",
                  modelValue: _ctx.model.providerName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.providerName) = $event)),
                  required: true,
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "readonly"]),
                _createVNode(_component_form_field, {
                  type: "select",
                  labelKey: "Country*",
                  labelValue: "Country*",
                  placeholderKey: "Select provider's country",
                  placeholderValue: "Select provider's country",
                  list: _ctx.countries,
                  modelValue: _ctx.model.countryIdentifier,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.countryIdentifier) = $event)),
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.checkForCountryRisk())),
                  required: true,
                  class: _normalizeClass(["w-100 me-4", _ctx.model.countryIdentifier ? 'mb-2' : '']),
                  readonly: _ctx.isReadOnly
                }, null, 8, ["list", "modelValue", "class", "readonly"]),
                (_ctx.countryRisk.key)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("img", _hoisted_10, null, 512), [
                        [_vShow, _ctx.countryRisk.key == _ctx.lowRiskLabel]
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [
                        [_vShow, _ctx.countryRisk.key == _ctx.moderateRiskLabel]
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
                        [_vShow, _ctx.countryRisk.key == _ctx.highRiskLabel]
                      ]),
                      _createVNode(_component_localized_text, {
                        localizedKey: "The selected country is",
                        text: "The selected country is"
                      }),
                      _createElementVNode("span", {
                        class: _normalizeClass(["mx-1 countryRisk countryRiskColorByType", _ctx.countryRisk.key])
                      }, _toDisplayString(_ctx.countryRisk.key) + ".", 3),
                      _createVNode(_component_localized_text, {
                        localizedKey: "Discover more here:",
                        text: "Discover more here:"
                      }),
                      _createElementVNode("a", _hoisted_13, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Country Risks",
                          text: "Country Risks"
                        })
                      ])
                    ]))
                  : (_ctx.model.countryIdentifier)
                    ? (_openBlock(), _createBlock(_component_localized_text, {
                        key: 1,
                        localizedKey: "Country risk is not available",
                        text: "Country risk is not available",
                        class: "d-block mb-4 pb-2 fs_14"
                      }))
                    : _createCommentVNode("", true),
                _createVNode(_component_form_field, {
                  type: "text",
                  labelKey: "Provider address",
                  labelValue: "Provider address",
                  placeholderKey: "Provider address",
                  placeholderValue: "Provider address",
                  modelValue: _ctx.model.address,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.address) = $event)),
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "readonly"]),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "btn btn-tertiary",
                        disabled: _ctx.saveDisabled,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save()))
                      }, [
                        (_ctx.providerIdentifier)
                          ? (_openBlock(), _createBlock(_component_localized_text, {
                              key: 0,
                              localizedKey: "Update",
                              text: "Update"
                            }))
                          : (_openBlock(), _createBlock(_component_localized_text, {
                              key: 1,
                              localizedKey: "Create",
                              text: "Create"
                            }))
                      ], 8, _hoisted_15)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_16,
                (_ctx.providerIdentifier)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Managed garments",
                          text: "Managed garments",
                          class: "fw_700 m-0"
                        }),
                        (!_ctx.isReadOnly)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-tertiary",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editGarmentManagement(-1)))
                            }, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Add garment management",
                                text: "Add garment management"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_provider_garment_productions_table, {
                        garmentProductions: _ctx.info.garmentProductions,
                        showCTAs: true,
                        onEditGarmentManagement: _ctx.editGarmentManagement,
                        onDeleteGarmentManagement: _ctx.deleteGarmentManagement
                      }, null, 8, ["garmentProductions", "onEditGarmentManagement", "onDeleteGarmentManagement"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeSection == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_docs_and_certifications, { providerIdentifier: _ctx.providerIdentifier }, null, 8, ["providerIdentifier"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeSection == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_water_footprints, { providerIdentifier: _ctx.providerIdentifier }, null, 8, ["providerIdentifier"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.activeSection == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_provider_due_diligence, { providerIdentifier: _ctx.providerIdentifier }, null, 8, ["providerIdentifier"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}